// src/services/userService.ts
import { apiClient } from './apiClient';
import { API_CONFIG } from '../utils/constants';

const userService = {
  // Get all users with pagination and filters
  getAllUsers: async (
    payload: any
  ): Promise<any> => {
    try {
      // Convert object to query string
      let queryString = '';
      if (payload) {
        const params = new URLSearchParams();
        Object.keys(payload).forEach(key => {
          if (payload[key] !== undefined && payload[key] !== null && payload[key] !== '') {
            params.append(key, payload[key].toString());
          }
        });
        queryString = params.toString();
      }
      
      
      const url = `users${queryString ? `?${queryString}` : ''}`;
      // console.log('url:', url);
      return await apiClient.get(url);
    } catch (error) {
      throw error;
    }
  },

  // Get single user by ID
  getUserById: async (userId: any): Promise<any> => {
    try {
      return await apiClient.get(`users/${userId}`);
    } catch (error) {
      throw error;
    }
  },

  // Create new user
  createUser: async (userData: any): Promise<any> => {
    try {
      return await apiClient.post(`users`, userData);
    } catch (error) {
      throw error;
    }
  },
  updateUserCredits: async (userId: any, creditData: any): Promise<any> => {
    try {
      return await apiClient.post(`users/${userId}/credits`, creditData);
    } catch (error) {
      throw error;
    }
  },

  // Update user
  updateUser: async (userId: any, userData: any): Promise<any> => {
    try {
      return await apiClient.put(`users/${userId}`, userData);
    } catch (error) {
      throw error;
    }
  },

  // Delete user
  deleteUser: async (userId: any): Promise<any> => {
    try {
      return await apiClient.delete(`users/${userId}`);
    } catch (error) {
      throw error;
    }
  },

  // Get statistics
  getStatistics: async (): Promise<any> => {
    try {
      return await apiClient.get(`users/statistics`);
    } catch (error) {
      throw error;
    }
  },

  // Bulk actions
  bulkAction: async (bulkData: any): Promise<any> => {
    try {
      return await apiClient.post(`users/bulk-action`, bulkData);
    } catch (error) {
      throw error;
    }
  },

  // User status actions
  activateUser: async (userId: any): Promise<any> => {
    try {
      return await apiClient.put(`users/${userId}/activate`);
    } catch (error) {
      throw error;
    }
  },

  deactivateUser: async (userId: any): Promise<any> => {
    try {
      return await apiClient.put(`users/${userId}/deactivate`);
    } catch (error) {
      throw error;
    }
  },

  suspendUser: async (userId: any): Promise<any> => {
    try {
      return await apiClient.put(`users/${userId}/suspend`);
    } catch (error) {
      throw error;
    }
  },

  // Update user status
  updateUserStatus: async (userId: any, status: any): Promise<any> => {
    try {
      return await apiClient.put(`users/${userId}/status`, status);
    } catch (error) {
      throw error;
    }
  },

  // Reset password
  resetPassword: async (userId: any, passwordData: any): Promise<any> => {
    try {
      return await apiClient.put(`users/${userId}/reset-password`, passwordData);
    } catch (error) {
      throw error;
    }
  },

  // Search users
  searchUsers: async (query: any): Promise<any> => {
    try {
      return await apiClient.get(`users/search?q=${encodeURIComponent(query)}`);
    } catch (error) {
      throw error;
    }
  },
  getCredit: async (userId: any): Promise<any> => {
    try {
      return await apiClient.get(`users/${userId}/credit`);
    } catch (error) {
      throw error;
    }
  },
};

export default userService;